<template>
  <div>
    <div>
      <el-button size="mini" type="primary text2" @click="onBind(1,1)">欠 款</el-button>
      <el-button size="mini" type="primary text2" @click="onBind(1,2)">交 清</el-button>
      <!--    <el-button size="mini" type="primary text2" @click="searchs">应收款</el-button>-->

      <el-button size="mini" type="primary text2" @click="onBind(2,0)">预收款</el-button>
      <el-button size="mini" type="primary text2" @click="onBind(3,0)">押金</el-button>
      <!--    <el-button size="mini" type="primary text2" @click="searchs">已缴款</el-button>-->

    </div>
    <div>
      <finance-common-table v-if="model_id===1" :house_id="house_id" :customer_id="id" :state="state" />
      <finance-deposit v-if="model_id===2" :house_id="house_id" :customer_id="id" />
      <finance-advance v-if="model_id===3" :house_id="house_id" :customer_id="id" />
    </div>
  </div>
</template>
<!--
欠 款
 交 清
 应收款
 预收款
 押金
 已缴款
 催缴明细-->
<script>
import FinanceCommonTable from "./finance/finance-common-table";
import FinanceDeposit from "./finance/finance-deposit";
import FinanceAdvance from "./finance/finance-advance";
export default {
  name: "finance-editor",
  props:{
    id:{
      type:Number,
      default(){
        return 0
      }
    },
    is_edit:{
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return{
      personalEditorVisable: false,
      enterpriseEditorVisable: false,
      personalTabIndex: 'personal-basic-editor',
      enterpriseTabIndex: 'enterprise-editor',
      house_id:0,
      model_id:1,
      state:1
    }
  },
  components: {
    FinanceAdvance,
    FinanceDeposit,
    FinanceCommonTable,
    'personal-basic-editor': () => import('./personal-basic-editor.vue'),
    'personal-extend-editor': () => import('./personal-extend-editor.vue'),
    'enterprise-editor': () => import('./enterprise-editor.vue'),
    'family-document-editor': () => import('./family-document-editor.vue'),
  },
  methods:{
    onBind(model,state){
      this.model_id=model;
      this.state=state
    }
  }

}
</script>

<style lang="scss" scoped>
@import "./common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/finance-editor.vue